import type { EventExtra } from '@cocoonspace/sdk-js/types/eventExtra'
import { cn } from '@cocoonspace/ui/lib/utils'

export const ExtraTitle = ({
	extra,
	className,
}: {
	extra?: Pick<EventExtra, 'title'>
	className?: string
}) => <strong className={cn(className)}>{extra?.title}</strong>
